import { getSharedState } from "./windowBus";

// autolock.ts imports dom.ts (for lockOverlay), so React must never import
// it directly - same standing rule as albumsBridge.ts. pauseInactivityForMedia/
// resumeInactivityAfterMedia do more than flip appState.mediaPlaying (they
// also clear/reschedule the lock timers), so React's useAudioPlayer can't
// just set the flag directly either - it needs the real functions, via
// this bridge.
export interface AutolockBridge {
  pauseInactivityForMedia: () => void;
  resumeInactivityAfterMedia: () => void;
  resetInactivityTimer: () => void;
}

interface AutolockBridgeState {
  current: AutolockBridge | null;
}

function state(): AutolockBridgeState {
  return getSharedState<AutolockBridgeState>("__autolockBridgeState", () => ({ current: null }));
}

export function registerAutolockBridge(bridge: AutolockBridge): void {
  state().current = bridge;
}

export function getAutolockBridge(): AutolockBridge | null {
  return state().current;
}
